var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "configuration-preview-container" },
    [
      _c("v-card", { staticClass: "preview-card-container" }, [
        _c("div", { staticClass: "preview-details-container" }, [
          _c("h3", [_vm._v("Preview")]),
          _vm._v(" "),
          _c("p", { staticClass: "details-title-label" }, [
            _vm._v("Workspace")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "details-title" }, [
            _vm._v(_vm._s(_vm.workspaceLabel))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "details-title-label mt-5" }, [
            _vm._v("Mandatory-buildings")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "details-list-container" },
            _vm._l(_vm.selectedBuildings, function(building, index) {
              return _c("div", { key: index }, [
                _c("p", { staticClass: "building-title" }, [
                  _vm._v(_vm._s(_vm.getBuildingLabel(building)))
                ])
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-container" },
            [
              _c(
                "v-btn",
                { staticClass: "previousBtn", on: { click: _vm.cancel } },
                [_vm._v("\n                    Cancel\n                ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "preview-input-container" }, [
            _c("p", { staticClass: "details-title-label" }, [
              _vm._v("Percentages")
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                staticClass: "preview-input",
                attrs: { id: "percentage1", type: "number" },
                on: { input: _vm.inputHandler }
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "preview-input",
                attrs: { id: "percentage2", type: "number" },
                on: { input: _vm.inputHandler }
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                staticClass: "preview-input",
                attrs: { id: "percentage3", type: "number" },
                on: { input: _vm.inputHandler }
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "preview-input",
                attrs: { id: "percentage4", type: "number" },
                on: { input: _vm.inputHandler }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "preview-map-container" }, [
          _c("h3", { staticClass: "map-title" }, [_vm._v("Map")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "map-container" },
            [
              _c("workspace-map", {
                ref: "workspaceMap",
                attrs: {
                  polygon: _vm.getSelectedPolygon,
                  workspace: _vm.getSelectedWorkspace,
                  "draw-polygon": false,
                  "view-all-workspaces": false,
                  "is-npv": true,
                  "is-npv-preview": true,
                  buildings: _vm.selectedBuildings
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0639fd52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0639fd52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/views/ConfigurationPreview.vue
// module id = null
// module chunks = 